import debounce from 'lodash/debounce'
import get from 'lodash/get'
import React from 'react'
import { connect } from 'react-redux'

import {
  getBatchMode,
  getPartiallySelectedTagsFromState,
} from '@disco/state-management/selectors/contacts'

import type { Contact } from 'types/list'
import type { State } from 'types/redux'

import TagList from 'components/explorer/pane/tag-list'

const mapStateToProps = (state: State, props: any): any => {
  const { contact } = props
  return {
    partiallySelectedTags:
      contact && contact.editMode
        ? getPartiallySelectedTagsFromState(state)
        : undefined,
    batchMode: contact && contact.editMode ? getBatchMode(state) : undefined,
  }
}

type Props = {
  contact: Contact
  partiallySelectedTags: string[] | null | undefined
  batchMode: boolean | null | undefined
  onFieldChange: (...args: Array<any>) => any
  onFieldValueAdd: (...args: Array<any>) => any
  onFieldValueRemove: (...args: Array<any>) => any
  updateContacts: (...args: Array<any>) => any
}

class ContactsTagList extends React.Component<Props> {
  _onTagAdd = (tag: string) => {
    const { contact, onFieldValueAdd } = this.props
    onFieldValueAdd(contact, 'tags', tag)

    this._scheduleTagUpdate()
  }
  _onTagRemove = (tag: string) => {
    const { contact, onFieldValueRemove } = this.props
    onFieldValueRemove(contact, 'tags', tag)

    this._scheduleTagUpdate()
  }
  _onBatchTagAdd = (tag: string) => {
    const { onFieldValueAdd, contact } = this.props
    onFieldValueAdd(contact, 'tags', tag)
  }
  _onBatchTagRemove = (tag: string) => {
    const { onFieldValueRemove, contact } = this.props
    onFieldValueRemove(contact, 'tags', tag)
  }
  _scheduleTagUpdate = debounce(() => this._updateTags(), 1000)
  _updateTags = () => {
    const { contact, updateContacts } = this.props

    if (contact && contact.pendingChanges && contact.pendingChanges.tags)
      updateContacts([contact]).catch(() => {})
  }

  render() {
    const { contact, partiallySelectedTags, batchMode } = this.props
    const tagsValue = get(contact, 'pendingChanges.tags', contact.tags || [])
    return (
      <TagList
        tagType="contact"
        tags={tagsValue}
        partiallySelectedTags={batchMode ? partiallySelectedTags : undefined}
        onTagRemove={batchMode ? this._onBatchTagRemove : this._onTagRemove}
        onTagAdd={batchMode ? this._onBatchTagAdd : this._onTagAdd}
        type="fixed"
        preventMenuClose
        displaySelectedTagsInMenu
      />
    )
  }
}

export default connect(mapStateToProps)(ContactsTagList) as any
